import { buildHostProfileListingRoute } from 'utils/routes';

export const URL_HS_MAIN_PAGE = '/';
export const URL_HS_SEARCH_HOST_PAGE = '/search-host';
export const URL_HS_RENO_CALC_PAGE = '/reno-calculator';
export const URL_HS_ENQUIRY_PAGE = '/enquiry';
export const URL_HS_HOST_REGISTER_PAGE = '/register/host';
export const URL_HS_HOST_LISTING_PAGE = buildHostProfileListingRoute();

export const URL_HAS_MAIN_PAGE = 'https://hostastay.com/';
export const URL_HAS_CAMPAIGN_PAGE = 'https://hostastay.com/campaign/';
export const URL_HAS_HOST_PROTECT_PAGE = 'https://hostastay.com/host-protect/';
export const URL_HAS_ABOUT_US_PAGE = 'https://hostastay.com/about-us/';
export const URL_HAS_TEAM_PAGE = 'https://hostastay.com/about-us/the-team/';
export const URL_HAS_EVENTS_PAGE = 'https://hostastay.com/events/';
export const URL_HAS_BLOG_PAGE = 'https://hostastay.com/blog/category/blog/';
export const URL_HAS_RESOURCES_PAGE = 'https://hostastay.com/resources/';
export const URL_HAS_HOST_PAGE = 'https://www.hostastay.com/host/';
export const URL_HAS_FAQ_PAGE = 'https://hostastay.com/faq/';
export const URL_HAS_LEGAL_TERMS_PAGE = 'https://hostastay.com/legal-terms/';
export const URL_HAS_HOST_360 = 'https://www.hostastay.com/host/host360';

export const URL_HP_PAGE = 'https://hostastay.com/hostplatform/';
export const URL_DAS_PAGE = 'http://www.designastay.com/';

export const URL_FB_PAGE = 'https://www.facebook.com/hostastay/';
export const URL_INSTA_PAGE = 'https://www.instagram.com/hostastay/';
export const URL_YOUTUBE_PAGE = 'https://www.youtube.com/channel/UCl2h5Ghe0wnD7WLnWEJT9NQ';
export const URL_LINKEDIN_PAGE = 'https://www.linkedin.com/company/host-a-stay-berhad/';
